<template>
    <div class="contentWrapper">
        <div class="contentBlock">
            <h3>{{$t('content.textTitle')}}&nbsp;{{$t('content.'+filter)}}</h3>
                <router-link to="/content/"><button type="button" class="btn btn-all"><i class="fas fa-ban"></i>&nbsp;{{$t('content.all')}}</button></router-link> 
                <router-link to="/content/maps"><button type="button" class="btn btn-maps"><i class="fas fa-globe"></i>&nbsp;{{$t('content.maps')}}</button></router-link>              
                <router-link to="/content/weapons"><button type="button" class="btn btn-weapons"><i class="fas fa-crosshairs"></i>&nbsp;{{$t('content.weapons')}}</button></router-link>
                <router-link to="/content/skins"><button type="button" class="btn btn-skins"><i class="fas fa-paint-brush"></i>&nbsp;{{$t('content.skins')}}</button></router-link>  
                <router-link to="/content/clothes"><button type="button" class="btn btn-clothes"><i class="fas fa-tshirt"></i>&nbsp;{{$t('content.clothes')}}</button></router-link>                
                <router-link to="/content/gamemodes"><button type="button" class="btn btn-gameModes"><i class="fas fa-cog"></i>&nbsp;{{$t('content.gamemodes')}}</button></router-link>
                <router-link to="/content/missions"><button type="button" class="btn btn-missions"><i class="fas fa-book-open"></i>&nbsp;{{$t('content.missions')}}</button></router-link> 
                <router-link to="/content/other"><button type="button" class="btn btn-other"><i class="fas fa-star-of-life"></i>&nbsp;{{$t('content.other')}}</button></router-link> 
                    
                <div class="well well-sm">
                    <b>{{$t('content.authorsFilter')}}</b>
                </div>  
                <div class="alert alert-danger">
                    <b>{{$t('content.textInWorking')}}</b>
                </div>
                <div class="cWrap">
                    <div class="cBlock" v-for="(value, index) in filteredComponents" :style="{ 'background-image': 'url(https://mod.worms.pro/resources/covers/' + value.type + '/' + value.image + '.jpg)' }" @click="OpenContent(value.image)">
                        <p class="title" :class="'title-'+value.type">
                            {{index+1}}.&nbsp;{{value.title}}<br>
                            <span v-if="value.type=='gamemodes'" class="badge badge-gameModes"><i class="fas fa-cog"></i>&nbsp;{{$t('content.'+value.type)}}</span>
                            <span v-else-if="value.type=='maps'" class="badge badge-maps"><i class="fas fa-globe"></i>&nbsp;{{$t('content.'+value.type)}}</span>
                            <span v-else-if="value.type=='missions'" class="badge badge-missions"><i class="fas fa-book-open"></i>&nbsp;{{$t('content.'+value.type)}}</span>
                            <span v-else-if="value.type=='other'" class="badge badge-other"><i class="fas fa-star-of-life"></i>&nbsp;{{$t('content.'+value.type)}}</span>
                            <span v-else-if="value.type=='skins'" class="badge badge-skins"><i class="fas fa-paint-brush"></i>&nbsp;{{$t('content.'+value.type)}}</span>
                            <span v-else-if="value.type=='weapons'" class="badge badge-weapons"><i class="fas fa-crosshairs"></i>&nbsp;{{$t('content.'+value.type)}}</span>
                            <span v-else class="badge">{{$t('content.'+value.type)}}</span>
                        </p>
                        <p class="leftBadge">
                            <span class="fas fa-check game-green" v-if="value.game==1|value.game==3"></i>&nbsp;<b>W4M</b></span>
                            <span class="fas fa-times game-red" v-else></i>&nbsp;<b>W4M</b></span>
                        </p>
                        <p class="rightBadge">
                            <span class="fas fa-check game-green" v-if="value.game==2|value.game==3"><i class=""></i>&nbsp;<b>WUM</b></span>
                            <span class="fas fa-times game-red" v-else></i>&nbsp;<b>WUM</b></span>
                        </p>
                        <p class="subtitle" :class="'subtitle-'+value.type">
                            {{$t('text.ButtonReadMore')}}
                        </p>
                    </div>
                </div>
                <app-Popup v-show="isPopupOpen" @popclose="TakeClose">
                    <h3>{{$t(contentData.title)}}</h3>
                        <span v-if="contentData.type=='gamemodes'" class="badge badge-gameModes"><i class="fas fa-cog"></i>&nbsp;{{$t('content.'+contentData.type)}}</span>
                        <span v-else-if="contentData.type=='maps'" class="badge badge-maps"><i class="fas fa-globe"></i>&nbsp;{{$t('content.'+contentData.type)}}</span>
                        <span v-else-if="contentData.type=='missions'" class="badge badge-missions"><i class="fas fa-book-open"></i>&nbsp;{{$t('content.'+contentData.type)}}</span>
                        <span v-else-if="contentData.type=='other'" class="badge badge-other"><i class="fas fa-star-of-life"></i>&nbsp;{{$t('content.'+contentData.type)}}</span>
                        <span v-else-if="contentData.type=='skins'" class="badge badge-skins"><i class="fas fa-paint-brush"></i>&nbsp;{{$t('content.'+contentData.type)}}</span>                            
                        <span v-else-if="contentData.type=='weapons'" class="badge badge-weapons"><i class="fas fa-crosshairs"></i>&nbsp;{{$t('content.'+contentData.type)}}</span>
                        <span v-else class="badge">{{$t('content.'+contentData.type)}}</span>
                    {{ $t(contentData.type+'.'+contentData.text) }}
                    
                    <ul>
                        <li v-for="sub in contentData.subtexts">{{$t(contentData.type+'.'+sub)}}</li>
                    </ul>
                    <b>{{$t('authors.title')}}:</b><span v-for="author in contentData.authors">&nbsp;{{author}}&nbsp;</span>
                    <app-GalerySlider v-bind:galeryArray="contentData.galeryArray" v-bind:galeryAlbum="contentData.image"></app-GalerySlider>
                </app-Popup>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ModContent',
        data () {
            return {
                isPopupOpen: false,
                filter: 'all',
                content: 'none',
                contentData: {
                
                }
                
            }
        },
        components: {
            
        },          
        computed: {
            filteredComponents: function () {
                let filter = this.filter
                if (filter == 'all')filter = undefined
                if(filter != undefined)filter.toLowerCase()
                return this.$store.state.components.filter(function (comp) {
                    if(filter){
                    
                        let authors = comp.authors.map(function(item, index) {
                            return item.toLowerCase();
                        });
                    
                        return (comp.type.toLowerCase() == filter | authors.includes(filter))
                    }
                    else return true
                })
            }
        },
        watch: {
            $route(to, from) {
                this.filter = this.$route.params.option
                this.content = this.$route.params.content
                this.LoadContent()
            }
        },
        mounted() {
            this.filter = this.$route.params.option
            this.content = this.$route.params.content
            this.LoadContent()
        },
        methods: {
            OpenContent(val){
                let filter = this.filter
                let content = this.content
                if (content == undefined) content = "none"
                if (filter == undefined) filter = "all"
                if (val.toLowerCase() != content.toLowerCase()) this.$router.push('/content/'+filter+'/'+val)
                else this.isPopupOpen = true
            },
            LoadContent() {
                let setContent = {}
                let setSearchString = this.content.toLowerCase()
                if (this.content != undefined){
                    for (let i=0; i < this.$store.state.components.length; i++){
                        if (this.$store.state.components[i].image.toLowerCase() == setSearchString) {
                            this.contentData = this.$store.state.components[i]
                            break
                        }
                    }
                    this.isPopupOpen = true
                }
            },
            NewTabUrlOpen(val){
                alert(val)
                window.open(val, '_blank')
            },
            TakeClose() {
                this.isPopupOpen = false
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .cWrap {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-direction: row;
        flex-direction: row;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        -ms-flex-pack: justify;
        justify-content: space-around;
    }
    .cBlock {
        position: relative;
        height: 288px;
        width: 220px;
        margin: 10px 5px;
        background-color: #222;
        background-image: url('http://mod.worms.pro/ava/855762.jpg');
        background-size: 220px auto;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 3px; 
        box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);     
    }
    .cBlock:hover {
        box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    }
    .cBlock .subtitle {
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
        margin: 0;
        background-color: #4a76a8;
        height: 34px;
        color: #fff;
        font-weight: bold;
        line-height: 34px;
        text-align: center;
        text-indent: 0px;
    }
    .cBlock .subtitle-gamemodes {
        color: #fff;
        background-color: #305f64;
    }
    .cBlock .subtitle-maps {
        color: #fff;
        background-color: #3b5234;
    }
    .cBlock .subtitle-missions {
        color: #fff;
        background-color: #3d366f;
    }
    .cBlock .subtitle-weapons {
        color: #fff;
        background-color: #6c3944;
    }
    .cBlock .subtitle-skins {
        color: #fff;
        background-color: #b85a3f;
    }
    .cBlock .subtitle-clothes {
        color: #fff;
        background-color: #4d4d4d;
    }
    .cBlock .title {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;  
        background-color: #fff;
        height: 34px;
        font-weight: bold;
        line-height: 34px;
        text-align: center;
        text-indent: 0px;
    }
    .cBlock .leftBadge {
        position: absolute;
        bottom: 34px;
        left: 0px;  
        width: 50%;
        margin: 0;
        height: 25px;
        color: #fff;
        text-shadow: 1px 1px 1px #000;
    }
    .cBlock .rightBadge {
        position: absolute;
        bottom: 34px;
        right: 0px; 
        width: 50%;
        margin: 0;
        height: 25px;
        color: #fff;
        text-shadow: 2px 2px 2px #333;
    }
    .cBlock .game-red {
        color: #f33 !important;
    }
    .cBlock .game-green {
        color: #0f0;
    }


    

    .squareIcon {
        background-image:url(http://tpverstak.ru/wp-content/uploads/2017/05/kitty.jpg);
        background-position:center center;
        background-size:cover;
        border-radius: 50%;
        width:100px;
        height:100px;
    }
    .icon50 {
        display: inline-block;

        width: 100px;
        height: 100px;
        background-image: url('http://mod.worms.pro/resources/content/s/none.jpg');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
    }
    .icon50Fake {
        display: inline-block;
        background-color: #f00;
        width: 100px;
        height: 100px;
    }
    .btnDiscordLayout {
       margin-bottom: 5px;
    }
    .updateSpanLayout {
       margin-bottom: 10px;
    }
    .mediaLayout {
        background-color: #fff;
        box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);     
    }
    .media-left {
        background-color: #337ab7;
        padding: 0px;
    }
    .tdLayout {
        padding: 0px !important;
        margin-bottom: 0px;
    }
    th {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/ModContent.vue